import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
	selector: 'app-faq',
	templateUrl: './faq.component.html',
	styleUrls: ['./faq.component.styl'],
})
export class PixWithdrawChangeFaqComponent implements OnInit {

	showHelp: boolean;

	public cards: {
		title: string;
		shortText: string;
		text: string
	}[];

	selectedCard: {
		title: string;
		shortText: string;
		text: string
	};

	showDetail = false;

	constructor(public dialogRef: MatDialogRef<PixWithdrawChangeFaqComponent>) { }

	showDetails(card):void {
		this.selectedCard = card;

		this.showDetail = !this.showDetail;
	}

	ngOnInit() {
		this.constructCards();
	}

	constructCards() {
		this.cards = [{
			title: 'Como funciona o Pix Saque e o Pix Troco?',
			shortText: 'O Pix Saque e o Pix Troco vão permitir...',
			text:
				`<p class="paragraf">O Pix Saque e o Pix Troco vão
				permitir que as pessoas usem o Pix para sacar
				dinheiro em espécie em estabelecimentos comerciais
				(como padarias, lojas de departamento e supermercados)
				e caixas eletrônicos.<p>`
		},
		{
			title: 'Qual a diferença entre Pix Saque e Pix Troco?',
			shortText: 'A diferença entre os dois está no modo...',
			text:
				`<p class="paragraf">A diferença entre os dois está no modo como o saque vai funcionar:</p>
				<p class="paragraf">Pix Saque: o cliente faz um Pix para o estabelecimento
				e recebe este mesmo valor em dinheiro físico.
				Por exemplo: faz um Pix de R$ 100 e recebe R$ 100 em notas</p>
				<p class="paragraf">Pix Troco: nesse caso,
				o dinheiro físico recebido é a diferença entre o valor da
				compra e o valor pago ao estabelecimento com Pix. Por exemplo: a pessoa compra um produto de R$ 60,
				faz um Pix de R$75  e recebe R$ 15 de volta em espécie.<p>`
		},
		{
			title: 'Vai ter limite para transações do Pix Saque e Pix Troco?',
			shortText: 'Sim! O limite das transações do Pix Saque...',
			text:
				`<p class="paragraf">Sim!
				O limite das transações do Pix Saque e
				do Pix Troco será de R$ 500 durante o dia e
				 de R$ 100 durante a noite (entre 20h e 6h).
				 Mas os estabelecimentos que oferecerem essas funcionalidades poderão
				definir limites menores, caso prefiram.<p>`
		}];
	}

	onClose(): void {
		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/faq/faq.component.ts